import { getApiBaseUrl } from "@/lib/api/client";

export function clearSessionCookies() {
  const hostname = window.location.hostname;
  const backendDomain = new URL(getApiBaseUrl()).hostname.replace(/^back\./, "");
  const domains = new Set([hostname]);
  if (hostname === backendDomain || hostname.endsWith(`.${backendDomain}`)) domains.add(backendDomain);

  for (const name of ["session_id", "auth_token"]) {
    const expired = `${name}=; Path=/; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = expired;
    for (const domain of domains) document.cookie = `${expired}; Domain=${domain}`;
  }
}
